import { useModalsStore } from '@/shared/stores/modals.js'

export const useModals = () => {
  const { closeModal, openModal, getModalState } = useModalsStore()

  return {
    openModal,
    closeModal,
    getModalState,
  }
}
